(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-3column-cta"]) return;
  try {
    

    $(document).ready(function() {
        var settings = {
            arrows: false,
            draggable: true,
            infinite: true,
            dots: true,
            adaptiveHeight: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            responsive: [{
                breakpoint: 1024,
                settings: "unslick"
            },
            {
             breakpoint: 600,
             settings: {
                slidesToShow: 2,
             }
            }]
        }

        var $slides = $('.wayfx-block--global-3column-cta .grid');

        $(window).on('load resize orientationchange', function () {
            if ($(window).width() > 1023) {
                if ($slides.hasClass('slick-initialized')) {
                    $slides.slick('unslick');
                }
                $slides.show();
                return
            }
            if (!$slides.hasClass('slick-initialized')) {
                return $slides.slick(settings).show();
            }
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos2--product-showcase-card"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.showcase-product-grid').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            infinite: false,
            dots: false,
            variableWidth: true,
            touchThreshold: 100,
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos2--product-showcase-mini-card"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.showcase-product-grid').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            infinite: false,
            dots: false,
            variableWidth: true,
            touchThreshold: 100,
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["MOS2-Media"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-block--media-grid .wayfx-block__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            infinite: true,
            dots: true,
            adaptiveHeight: false,
            mobileFirst: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    adaptiveHeight: false,
                    arrows: true,
                    draggable: false
                }
            }]
      }).show();

      var settings = {
        arrows: false,
        draggable: true,
        infinite: false,
        dots: false,
        adaptiveHeight: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
                settings: "unslick"
            }
        }]
    }

    var $slides = $('.wayfx-block--media-grid .wayfx-row__one');

    $(window).on('load resize orientationchange', function () {
        if ($(window).width() > 1023) {
            if ($slides.hasClass('slick-initialized')) {
                $slides.slick('unslick');
            }
            $slides.show();
            return
        }
        if (!$slides.hasClass('slick-initialized')) {
            return $slides.each(function() {
                $(this).slick(settings).show();
            });
        }
    });

 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-before-after-slider"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-block--before-after__slider-active').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: false,
            infinite: true,
            swipe: false,
            dots: false
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-media-blocks"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-block--media-grid .wayfx-block__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            infinite: true,
            dots: true,
            adaptiveHeight: false,
            mobileFirst: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    adaptiveHeight: false,
                    arrows: true,
                    draggable: false
                }
            }]
      }).show();

      var settings = {
        arrows: false,
        draggable: true,
        infinite: false,
        dots: false,
        adaptiveHeight: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
                settings: "unslick"
            }
        }]
    }

    var $slides = $('.wayfx-block--media-grid .wayfx-row__one');

    $(window).on('load resize orientationchange', function () {
        if ($(window).width() > 1023) {
            if ($slides.hasClass('slick-initialized')) {
                $slides.slick('unslick');
            }
            $slides.show();
            return
        }
        if (!$slides.hasClass('slick-initialized')) {
            return $slides.each(function() {
                $(this).slick(settings).show();
            });
        }
    });

 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-product-experts"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-product__experts-list.wayfx-product__experts-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: false,
            infinite: true,
            dots: true
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-quotes"] && !window.DesignMode) return;
  try {
    
   $(document).ready(function() {
        $('.wayfx-block--home-what-experts-say .wayfx-block__slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              draggable: true,
              infinite: true,
              dots: true,
              adaptiveHeight: false,
              mobileFirst: true,
              responsive: [{
                  breakpoint: 768,
                  settings: {
                      adaptiveHeight: false,
                      arrows: true,
                      draggable: false,
                      dots: false,
                      slidesToShow: 2,
                      slidesToScroll: 1
                  }
              }]
        }).show();
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-slideshow"] && !window.DesignMode) return;
  try {
    

var heroSliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  speed: 300,
  draggable: true,
  infinite: true,
  adaptiveHeight: false,
  useTransform: false,
  mobileFirst: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [{
    breakpoint: 768,
    settings: {
      draggable: false
    }
  }]
};

var $slides = $('.wayfx-block--hero-slider');

document.addEventListener("shopify:section:unload", function(event) {
  $slides.slick('unslick');
});

document.addEventListener("shopify:section:load", function(event) {
  $slides.slick(heroSliderSettings);
});

$slides.slick(heroSliderSettings);


  } catch(e) { console.error(e); }
})();
})();
